/* eslint-disable no-undef */
import $ from "jquery";

const chapters = () => {
  const init = () => {
    chapterAnimation();
    popupChapter();
    chapterButton();
  };

  // Popup Chapter
  const popupChapter = () => {
    // Buttons
    const backBtn = $(".js-PopupButton__Back");
    const nextBtn = $(".js-PopupButton__Next");
    const openPopup = $(".js-Navigator_Chapter__Btn");
    const closeBtnPopup = $(".js-PopupCloseChapter_Btn");
    const backButtonPopupChapter = $(".js-PopupButtonChapter__Back");

    // Chapters
    const popupChapter = $(".js-PopupCloseChapter");
    const popupOverlay = $(".js-PopupCloseChapter__Overlay");
    // popupOverlay.hide();
    // popupChapter.hide();

    const closeAction = () => {
      const targetSlide = popupChapter;
      const targetOverlay = popupOverlay;

      targetOverlay.fadeToggle(600).css('display', 'flex');

      targetSlide.slideToggle({
        duration: 400,
        direction: "up",
      }).css('display', 'flex');
    };

    const nextAction = (el) => {
      const target = el.data("target");
      $(".js-DetailsQuestion").attr("open", false);
      $(`#${target}`).attr("open", true);
    };

    closeBtnPopup.on("click", function () {
      closeAction($(this));
    });

    backButtonPopupChapter.on("click", function () {
      closeAction($(this));
    });

    backBtn.on("click", function () {
      closeAction($(this));
    });

    openPopup.on("click", function () {
      closeAction($(this));
    });

    nextBtn.on("click", function () {
      nextAction($(this));
    });
  };

  // Chapter Button
  const chapterButton = () => {
    // Buttons
    const nextBtn = $(".js-ChapterNext__Btn");
    const prevBtn = $(".js-ChapterPrev__Btn");
    const surveyChoices = $(
      ".mi-SurveyOptions__Choices_ChoiceLabel input[type=radio]"
    );

    const ChapterAction = (el) => {
      const target = el.data("target");

      if (target === "Chapter__Dashboard") {
        $(".mi-Popup__CloseChapter_Container").show();
      } else {
        $(".js-Chapter__Content").attr("open", false);
        $(`#${target}`).attr("open", true);
        // trigger animation
        if (target === "Chapter__Complete") {
          $(".js-mi-Character--ChapterCompleted").show();
        }
        if (target === "Chapter__Start" || target === "Chapter__Start_Survey") {
          $(".js-mi-Character--ChapterWelcome").show();
        }
      }
    };

    // Enable or disable navigation buttons based on current index and checked radios
    const updateNavigationButtons = () => {
      let details = $(".Chapter--Survey[open]");
      let radios = details.find(".js-QuestionChoiceCheck input[type=radio]");
      let button = details.find(".js-ChapterNext__Btn");
      // let isChecked = false;

      if (details.hasClass("Chapter--Survey")) {
        let detailsID = details.attr("id");
        let numbRadioButtons = $(
          "#" + detailsID + " .js-QuestionChoiceCheck > input[type=radio]"
        ).length;

        // Add your logic for checking if a specific number of radios are checked
        let checkedRadios = radios.filter(":checked").length;
        // console.log(checkedRadios, numbRadioButtons);

        if (checkedRadios === numbRadioButtons / 2) {
          button.prop("disabled", false);
          // isChecked = true;
        } else {
          button.prop("disabled", true);
          // isChecked = false;
        }
        // console.log(numbRadioButtons / 2)
      }
      //  else {
      //   // Check if any radio is checked within the current <details> section
      //   isChecked = radios.filter(":checked").length === radios.length / 2;
      // }
      // button.prop("disabled", !isChecked);
    };

    surveyChoices.on("change", function (e) {
      e.preventDefault();
      updateNavigationButtons();
    });

    nextBtn.on("click", function () {
      const el = {
        target: ".js-Chapter__Content[open]",
      };

      const dataform = $(el.target).data("data_form");

      ChapterAction($(this));
      updateNavigationButtons();
      SavetoLocalStorage(atob(dataform));
      if (
        nextBtn.attr("id") == "js-stepButtonSurvey" &&
        !nextBtn.hasClass("btn-submit-survey")
      ) {
        nextBtn.prop("disabled", true);
      }
    });

    prevBtn.on("click", function () {
      ChapterAction($(this));
    });
  };

  const SavetoLocalStorage = (dataform) => {
    const formdata = dataform.split(",");
    const formNumber = formdata[1];
    const formTotal = formdata[2];
    const formID = formdata[0];

    var progress = localStorage.getItem("progress");
    if (progress) {
      progress = JSON.parse(progress);
    } else {
      progress = {
        data: [],
      };
    }

    var newChapterNumber = formNumber;
    var chapterExists = progress.data.some(function (chapter) {
      return chapter.id === formID && chapter.number === newChapterNumber;
    });

    if (!chapterExists) {
      var newData = {
        id: formID,
        total: formTotal,
        number: formNumber,
      };
      progress.data.push(newData);

      localStorage.setItem("progress", JSON.stringify(progress));
    }

    if (formNumber == formTotal) {
      let progress_all = localStorage.getItem("progress");
      let postData = {
        nonce: "n0nc3",
        action: "save_chapter",
        progress: btoa(progress_all),
      };

      $.ajax({
        type: "POST",
        url: themeParams.ajaxUrl,
        data: postData,
        dataType: "json", // and this
        success: function () {
          localStorage.removeItem("progress");
        },
        error: function () {},
      });
    }
  };

  // Hide Chapter Animation
  const chapterAnimation = () => {
    $(".js-mi-Character--ChapterCompleted").hide();
    $(".js-mi-Character--ChapterWelcome").hide();
  };

  init();
};

chapters();
